import { theme } from "kosmos-ui/lib";
import { TVectorProps } from "kosmos-ui/lib/types/vectors";

function EditIcon({ height = "100px", style }: TVectorProps) {
  return (
    <svg height={height} viewBox="0 0 100 100" style={style}>
      <defs>
        <linearGradient id="gradient">
          <stop stopColor={theme.colorsPalette.blue.dark} offset="0%" />
          <stop stopColor={theme.colorsPalette.cyan.default} offset="100%" />
        </linearGradient>
      </defs>

      <path
        fill={theme.colorsPalette.green.default}
        d="M81.8,15.7c-1.8-1.5-4.1-2.2-6.5-2s-4.5,1.3-6,3.1L45.5,45.4c-2.3,2.7-3.4,6.1-3.1,9.9c0.1,1.8,1,3.4,2.3,4.5  c1.2,1,2.7,1.6,4.5,1.6c0.2,0,0.5,0,0.8,0c3.5-0.3,6.9-2,9.2-4.7l23.7-28.5c1.5-1.8,2.3-4.1,2-6.5C84.8,19.4,83.6,17.2,81.8,15.7z   M55.2,53.4c-1.4,1.6-3.4,2.7-6,2.9c-0.8,0-1.4-0.5-1.5-1.6c-0.2-2.1,0.5-4.2,1.9-5.8l16.2-19.4c0.2-0.2,0.5-0.2,0.7-0.1l4.8,4  c0.2,0.2,0.2,0.5,0.1,0.7L55.2,53.4z M78.9,24.9l-3.6,4.4c-0.2,0.2-0.5,0.2-0.7,0.1l-4.8-4c-0.2-0.2-0.2-0.5-0.1-0.7l3.6-4.4  c0.6-0.7,1.5-1.2,2.5-1.3c0.1,0,0.2,0,0.3,0c0.8,0,1.7,0.3,2.3,0.8l0,0c0.7,0.6,1.2,1.5,1.3,2.5C79.8,23.2,79.5,24.1,78.9,24.9z"
      />
      <path
        fill={theme.colorsPalette.green.default}
        d="M64.4,86.4H28.2c-7.3,0-13.2-5.9-13.2-13.2V37c0-7.3,5.9-13.2,13.2-13.2h19.5c1.4,0,2.5,1.1,2.5,2.5l0,0   c0,1.5-1.2,2.8-2.8,2.8H28.2c-4.4,0-7.9,3.5-7.9,7.9v36.2c0,4.4,3.5,7.9,7.9,7.9h36.2c4.4,0,7.9-3.5,7.9-7.9V54.5   c0-1.4,1.1-2.5,2.5-2.5h0.3c1.4,0,2.5,1.1,2.5,2.5v18.8C77.6,80.5,71.7,86.4,64.4,86.4z"
      />
    </svg>
  );
}

export default EditIcon;
